import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Player from "./player";

interface IProps {
  activeIndex: number;
  setIndex: (index: number) => void;
  totalIndex: number;
  handleSeek: (time: number) => void;
  setLyricTime: (time: number, index: number) => void;
  currentTime: number;
  duration: number;
  togglePlay: () => void;
  isPlaying: boolean;
  setFreePlay: (bool: boolean) => void;
  GoToTime: (value: number) => void;
  slowDown: (isSlow: boolean) => void;
  save: () => void;
  loading: boolean;
}
const SyncController = ({
  activeIndex,
  totalIndex,
  setIndex,
  handleSeek,
  setLyricTime,
  currentTime,
  duration,
  togglePlay,
  isPlaying,
  setFreePlay,
  GoToTime,
  slowDown,
  save,
  loading
}: IProps) => {
  const UpButton = () => {
    if (activeIndex !== 0) {
      setFreePlay(false);
      setLyricTime(0, activeIndex);
      setIndex(activeIndex - 1);
    }
  };

  const DownButton = () => {
    if (totalIndex !== activeIndex) {
      setFreePlay(false);
      setLyricTime(currentTime, activeIndex);
      setIndex(activeIndex + 1);
    }
  };
  return (
    <Container>
      <ButtonsContainer>
        <Button
          onClick={UpButton}
          isactive={activeIndex !== 0 ? "true" : "false"}
        >
          <ButtonIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M25.3346 20L16.0013 12L6.66797 20"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </ButtonIcon>
        </Button>
        <Button
          isactive={totalIndex !== activeIndex ? "true" : "false"}
          onClick={DownButton}
        >
          <ButtonIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M25.3346 12L16.0013 20L6.66797 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </ButtonIcon>
        </Button>
      </ButtonsContainer>
      <Player
        handleSeek={(time) => handleSeek(time)}
        duration={duration}
        currentTime={currentTime}
        togglePlay={togglePlay}
        isPlaying={isPlaying}
        GoToTime={(time) => GoToTime(time)}
        slowDown={(isSlow) => slowDown(isSlow)}
        save={() => save()}
        loading={loading}
      />
    </Container>
  );
};

export default SyncController;

const Container = styled.div`
  position: fixed;
  bottom: 0;
  width: 75%;
  @media only screen and (max-width: 769px) {
    width: 90%;
  }
`;

const ButtonsContainer = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 0;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Button = styled.div<{ isactive: string }>`
  width: 22.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
  background-color: ${(props) =>
    props.isactive !== "true" ? Colors.grey600 : Colors.white100};
  color: ${(props) =>
    props.isactive !== "true" ? Colors.white100 : Colors.grey900};
  border-radius: 0.8rem;
  cursor: pointer;
  @media only screen and (max-width: 769px) {
    width: 20rem;
  }
`;

const ButtonIcon = styled.div`
  width: 3.2rem;
  height: 3.2rem;
`;
